import axios, { AxiosResponse } from 'axios'

const loginMynaviApi = async (): Promise<AxiosResponse> => axios.get('/admin/mynavi_user/sign_in')

const mynaviServices = {
  loginMynaviApi,
}

export default mynaviServices
